import { call, all, takeEvery, put, fork } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { getToken, clearToken } from '../../helpers/utility';
import AuthHelper from '../../helpers/authHelper';
import SuperFetch from '../../helpers/superFetch';
import { notification } from '@isomorphic/shared/isomorphic/components';
import actions from './actions';

/*
Login Sagas
*/
export function* loginRequest() {
  yield takeEvery(actions.LOGIN_REQUEST, function*({ userInfo }) {
    const result = yield call(AuthHelper.login, userInfo);
    if (result.error) {
      yield put({
        type: actions.LOGIN_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: result.token,
        user: result,
      });
    }
  });
}

export function* forgotPassword() {
  yield takeEvery(actions.FORGOT_PASSWORD, function*({ userInfo }) {
    const result = yield call(AuthHelper.forgotPassword, userInfo);
    if (result.Status === 'success') {
      console.log(result)
      yield notification('success', result.Message);
      yield put(push('/signin'));
    } else {
      yield notification('error', result.Message);
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    yield localStorage.setItem('id_token', payload.token);
    yield put(push('/'));
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*(payload) {
    yield notification('error', payload.error);
  });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function*() {
    clearToken();
    yield put(push('/signin'));
  });
}

/*
Signup Sagas
*/
export function* signupRequest() {
  yield takeEvery(actions.SIGNUP_REQUEST, function*({ userInfo }) {
    const result = yield call(AuthHelper.signup, userInfo);
    if (result.error) {
      yield put({
        type: actions.SIGNUP_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actions.SIGNUP_SUCCESS,
        user: result.user,
        profile: result.model,
      });
    }
  });
}

export function* signupSuccess() {
  yield takeEvery(actions.SIGNUP_SUCCESS, function*(payload) {
    yield localStorage.setItem('id_token', payload.token);
    yield localStorage.setItem('user', payload.user);

    if (payload.user) {
      yield notification(
        'success',
        `Account ${payload.user.username} created successfully.`
      );
      yield put(push('/'));
    }
  });
}

export function* signupError() {
  yield takeEvery(actions.SIGNUP_ERROR, function*(payload) {
    yield notification('error', payload.error);
  });
}

/*
AuthCheck
*/
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: 'Profile',
      });
    }
  });
}

export function* settingsUpdate() {
  yield takeEvery(actions.SETTINGS_UPDATE, function*({ updatedUser }) {
    let users = [];
    users.push(updatedUser);
    const data = { Data: { Users: users } };
    console.log('POST user/update (self) json:');
    console.log(JSON.stringify(data));
    const response = yield call(SuperFetch.post, 'user/update', data);
    if (response.Status !== 'error') {
      let user = response.Data.Users[0];
      yield put({
        type: actions.SETTINGS_UPDATE_SUCCESS,
        user: user,
      });
    } else {
      yield notification('error', response.Message);
    }
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(forgotPassword),
    fork(signupRequest),
    fork(signupSuccess),
    fork(signupError),
    fork(settingsUpdate),
    fork(logout),
  ]);
}
